import { BlankBlock } from 'components/common';
import { BlankBlockContainer } from 'components/layouts';

export const FunctionalityAdjustmentPage = () => {
  return (
    <BlankBlockContainer>
      <BlankBlock />;
    </BlankBlockContainer>
  );
};
